var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"TRC-AppButtonSelection__Buttons"},_vm._l((_vm.options),function(value){return _c('app-action-button',{key:value,class:{
            'TRC-AppButtonSelection': !_vm.closeButtons,
        },attrs:{"disableButtonCss":_vm.disableButtonCss,"outline":!_vm.hasOptionSelected(value)},on:{"click":function($event){return _vm.selectOption(value)}}},[_vm._v("\n        "+_vm._s(value)+"\n    ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }